export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">精彩看点</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            最新动画PV、漫画预告与精彩剪辑，一站式掌握动漫圈前沿动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {/* Media 1 */}
          <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20manga%20panel%20style%20illustration%20of%20an%20intense%20battle%20scene%20in%20urban%20setting%2C%20explosive%20energy%20effects%20with%20blue%20and%20purple%20tones%2C%20dynamic%20action%20composition%20with%20multiple%20combatants%2C%20modern%20manga%20art%20style%20with%20speed%20lines%20and%20impact%20frames%2C%20cinematic%20lighting&width=800&height=450&seq=media-01&orientation=landscape"
                alt="《咒术回战》涩谷事变PV"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                  <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-white text-xs">03:24</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-1.5">《咒术回战》涩谷事变PV</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">五条悟 vs 漏瑚·花御·真人 三线激战！史上最震撼战斗场面公开</p>
            </div>
          </article>

          {/* Media 2 */}
          <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20manga%20panel%20style%20illustration%20of%20a%20fantasy%20alchemy%20competition%20scene%2C%20floating%20cauldrons%20and%20mystical%20flames%2C%20Chinese%20manhua%20art%20style%20with%20rich%20gold%20and%20red%20color%20palette%2C%20dramatic%20composition%20with%20multiple%20characters%2C%20grand%20ceremonial%20atmosphere&width=800&height=450&seq=media-02&orientation=landscape"
                alt="《斗破苍穹》年番预告"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                  <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-white text-xs">05:18</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-1.5">《斗破苍穹》年番预告</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">萧炎晋升斗尊！丹塔大会篇正式开启，全新角色建模震撼亮相</p>
            </div>
          </article>

          {/* Media 3 */}
          <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20manga%20panel%20style%20illustration%20of%20a%20shadow%20army%20commander%20with%20dark%20soldiers%2C%20epic%20scale%20battlefield%20with%20purple%20auras%2C%20Korean%20webtoon%20art%20style%20with%20cinematic%20lighting%2C%20dramatic%20wide%20angle%20composition%2C%20ominous%20dark%20sky%20background&width=800&height=450&seq=media-03&orientation=landscape"
                alt="《我独自升级》第二季"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                  <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-white text-xs">02:47</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-1.5">《我独自升级》第二季</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">济州岛突袭篇动画化决定！暗影军团大军压境，成振宇最强形态解禁</p>
            </div>
          </article>

          {/* Media 4 */}
          <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20manga%20panel%20style%20illustration%20of%20a%20celestial%20ascension%20scene%20with%20lightning%20and%20golden%20clouds%2C%20mythical%20Chinese%20fantasy%20style%20with%20flowing%20robes%20and%20divine%20light%2C%20epic%20vertical%20composition%2C%20warm%20golden%20and%20white%20color%20scheme%2C%20heavenly%20palace%20in%20background&width=800&height=450&seq=media-04&orientation=landscape"
                alt="《完美世界》特别篇"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                  <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-white text-xs">04:35</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-1.5">《完美世界》特别篇</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">石昊渡劫飞升仙界！荒天帝传说拉开序幕，超越极境的至尊之路</p>
            </div>
          </article>

          {/* Media 5 */}
          <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20manga%20panel%20style%20illustration%20of%20a%20dark%20continent%20exploration%20scene%2C%20mysterious%20creatures%20and%20uncharted%20wilderness%2C%20classic%20Japanese%20manga%20art%20style%20with%20detailed%20ink%20work%2C%20adventurous%20composition%20with%20explorers%2C%20dark%20and%20atmospheric%20lighting&width=800&height=450&seq=media-05&orientation=landscape"
                alt="《全职猎人》复刊特报"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                  <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-white text-xs">08:12</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-1.5">《全职猎人》复刊特报</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">黑暗大陆篇最新话公开！富坚义博亲笔原画赏析，猎人粉不容错过</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}